module.exports = __webpack_public_path__ + "static/media/GreenInactiveIcon.feb28675.svg";